import * as React from "react";
import { educationData } from "../data";
import { getLocalizedText } from "../util";
import { useLang } from "../lang";

const Education: React.FC = () => {
  const { langEn } = useLang();
  return (
    <div id="education" className="container justify-content-center mb-4">
      <p className="title">{langEn ? "Education" : "学歴"}</p>

      <div className="row">
        <div className="col-md-12 mb-2">
          <ul className="mb-0">
            {educationData.map((item, i) => (
              <li key={i}>
                <span className="degree">{getLocalizedText(item.degree, langEn)}</span>:
                <span className="ml-1">{getLocalizedText(item.affiliation, langEn)}</span>
                <span className="ml-1">({getLocalizedText(item.term, langEn)})</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Education;
